
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Hamburger from '@/components/Hamburger/index.vue'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import {
  getDisplayName,
  getAvatar,
  getuserCurrentAppName,
  getuserCurrentApp
} from '@/utils/cookies.ts'
import { isDashboardTicketType, timestampToDate } from '@/utils/commonFunc'
import { Route } from 'vue-router'
@Component({
  components: {
    Hamburger,
    Breadcrumb
  }
})
export default class extends Vue {
  @Prop({ default: true }) private showIcon!: boolean;
  @Prop({ default: false }) private dateFilterDefault!: boolean;
  private search = '';
  private dateFilter: any = '';
  private userCurrentAppName = '';

  expireTimeOption: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  get isDashboardTicketType() {
    return isDashboardTicketType()
  }

  // 是否在知音楼APP内
  get isInYach() {
    const ua = navigator.userAgent.toLocaleLowerCase()
    return ua.indexOf('yach') !== -1 || ua.indexOf('zhiyinlou') !== -1
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  // 头像，待完善
  get avatar() {
    return UserModule.avatar || getAvatar() || ''
  }

  get username() {
    return getDisplayName()
  }

  // navbar地区名称
  get showNavbarPlaceValue() {
    return AppModule.showNavbarPlaceValue
  }

  // 是否展示navbar搜索框；
  get showNavbarSeatch() {
    return AppModule.showNavbarSeatch
  }

  // 是否展示navbar时间筛选框
  get showNavbarDateFilter() {
    return AppModule.showNavbarDateFilter
  }

  mounted() {
    setTimeout(() => {
      this.userCurrentAppName = getuserCurrentAppName()
      if (this.dateFilterDefault) {
        this.dateFilter = [
          timestampToDate(new Date().getTime() - 3600 * 1000 * 24 * 7),
          timestampToDate(new Date().getTime())
        ]
      }
    }, 100)
  }

  // route改变时，重置navbar搜索框值；
  @Watch('$route')
  private onRouteChange(route: Route) {
    this.search = ''
    AppModule.SetNavbarSearch(this.search)
    this.dateFilter = []
    AppModule.SetNavbarDate(this.dateFilter)
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private handleHome() {
    this.$router.push({ path: '/' })
  }

  private async logout() {
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)

    type appIdType = '1' | '2' | '3' | '4' | '5';
    const appid: appIdType = getuserCurrentApp() as appIdType

    console.log(appid, 'appid退出登录')

    // TODO  工单入口退出登录
    const LogoutMap = {
      1:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      2:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      3:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      4:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_LOGIN_API,
      5:
        process.env.VUE_APP_LOGOUT_API +
        '?path=' +
        process.env.VUE_APP_ADMINI_LOGIN_API
    }

    await UserModule.LogOut()

    if (appid) {
      (window as any).location = LogoutMap[appid]
    } else {
      // 知音楼退出登录
      (window as any).location = LogoutMap['1']
    }
  }

  // 重新选择工单类型
  private async changeTicket() {
    // 清除相关数据
    await UserModule.UserChangeTicket()
    this.$router.push({
      name: 'jumper',
      query: { check_dash_perms: String(!isDashboardTicketType) },
      replace: true
    })
  }

  private handleSearch() {
    AppModule.SetNavbarSearch(this.search)
  }

  private handleDateFilter(date: []) {
    AppModule.SetNavbarDate(date)
  }
}
